<div
  [ngClass]="substitutionInterfaceCSS()"
>
  <div
    *ngIf="!substitutionInterfaceOpened"
    style="text-align: unset"
  >
    <div
      (click)="substituteClickHandler()"
    >
      <button
        class='btn btn-log btn-sm'
      >
        Заменить игрока
      </button>
    </div>
  </div>
  <div
    *ngIf="substitutionInterfaceOpened"
    class="substitutionSection"
  >
    <div>
      <input
        class="inputStyle"
        placeholder="Фамилия игрока"
        [ngbTypeahead]="searchASubstitute"
        [inputFormatter]="playerInputFormatter"
        [resultFormatter]="playerOutputFormatter"
        #instance="ngbTypeahead"
        (selectItem)="choseSubstitution = $event.item"
        [(ngModel)]="choseSubstitution"
        popupClass="substitutionsListDropdown"
      >
    </div>
    <div
      class="buttonsSection"
    >
      <div>
        <button
          (click)="acceptSubstitutionClickHandler()"
          [ngClass]="substituteButtonStyle()"
        >
          Заменить
        </button>
      </div>

      <div>
        <button
          (click)="declineSubstitutionClickHandler()"
          class="declineButtonStyle"
        >
          Отменить
        </button>
      </div>

    </div>
  </div>
</div>
